import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Save, Plus, Trash2 } from "lucide-react";

export default function FooterBuilder() {
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/cms/footer").then(({ data }) => setData(data || {})); }, []);
  if (!data) return <div className="p-8">Lade...</div>;
  const set = (patch) => setData({ ...data, ...patch });
  const save = async () => {
    setSaving(true);
    try {
      const { id, _id, salon_id, updated_at, ...p } = data;
      await api.put("/cms/footer", p);
    } finally { setSaving(false); }
  };

  const hours = data.opening_hours || [];
  const socials = data.socials || [];
  const legal = data.legal_links || [];

  return (
    <div className="p-8 lg:p-12 mv-fade-in max-w-3xl">
      <div className="flex items-end justify-between mb-10">
        <div>
          <p className="mv-label mb-2">Fußbereich</p>
          <h1 className="font-display text-4xl">Footer</h1>
        </div>
        <button data-testid="save-footer-btn" onClick={save} disabled={saving} className="mv-btn"><Save className="w-4 h-4" /> {saving ? "..." : "Speichern"}</button>
      </div>

      <div className="mv-card p-6 mb-6">
        <p className="mv-label mb-3">Kontakt</p>
        <div className="grid grid-cols-2 gap-3">
          <div className="col-span-2"><label className="block text-xs mb-1">Adresse</label><input className="mv-input" value={data.address || ""} onChange={(e) => set({ address: e.target.value })} /></div>
          <div><label className="block text-xs mb-1">Telefon</label><input className="mv-input" value={data.phone || ""} onChange={(e) => set({ phone: e.target.value })} /></div>
          <div><label className="block text-xs mb-1">E-Mail</label><input className="mv-input" value={data.email || ""} onChange={(e) => set({ email: e.target.value })} /></div>
          <div className="col-span-2"><label className="block text-xs mb-1">Copyright</label><input className="mv-input" value={data.copyright_text || ""} onChange={(e) => set({ copyright_text: e.target.value })} /></div>
        </div>
      </div>

      <div className="mv-card p-6 mb-6">
        <p className="mv-label mb-3">Öffnungszeiten</p>
        {hours.map((h, i) => (
          <div key={i} className="flex gap-2 mb-2">
            <input className="mv-input w-32" placeholder="Tag" value={h.day} onChange={(e) => { const a = [...hours]; a[i] = { ...h, day: e.target.value }; set({ opening_hours: a }); }} />
            <input className="mv-input flex-1" placeholder="Zeiten" value={h.hours} onChange={(e) => { const a = [...hours]; a[i] = { ...h, hours: e.target.value }; set({ opening_hours: a }); }} />
            <button onClick={() => set({ opening_hours: hours.filter((_, j) => j !== i) })} className="p-2"><Trash2 className="w-4 h-4 text-red-500" /></button>
          </div>
        ))}
        <button onClick={() => set({ opening_hours: [...hours, { day: "", hours: "" }] })} className="mv-btn-ghost text-xs"><Plus className="w-3 h-3" /> Hinzufügen</button>
      </div>

      <div className="mv-card p-6 mb-6">
        <p className="mv-label mb-3">Rechtliche Links</p>
        {legal.map((l, i) => (
          <div key={i} className="flex gap-2 mb-2">
            <input className="mv-input flex-1" placeholder="Label" value={l.label} onChange={(e) => { const a = [...legal]; a[i] = { ...l, label: e.target.value }; set({ legal_links: a }); }} />
            <input className="mv-input flex-1" placeholder="URL" value={l.url} onChange={(e) => { const a = [...legal]; a[i] = { ...l, url: e.target.value }; set({ legal_links: a }); }} />
            <button onClick={() => set({ legal_links: legal.filter((_, j) => j !== i) })} className="p-2"><Trash2 className="w-4 h-4 text-red-500" /></button>
          </div>
        ))}
        <button onClick={() => set({ legal_links: [...legal, { label: "", url: "" }] })} className="mv-btn-ghost text-xs"><Plus className="w-3 h-3" /> Hinzufügen</button>
      </div>

      <div className="mv-card p-6">
        <p className="mv-label mb-3">Newsletter</p>
        <label className="flex items-center gap-2 text-sm">
          <input type="checkbox" checked={!!data.newsletter_enabled} onChange={(e) => set({ newsletter_enabled: e.target.checked })} />
          Newsletter-Anmeldung im Footer anzeigen
        </label>
      </div>
    </div>
  );
}
